import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Header from "../../Component/Header";
import {
    Container,
    Row,
    Col,
    Card,
    Form,
    Table,
    Pagination,
    Dropdown,
    Offcanvas,
    Button,
    Badge,
} from "react-bootstrap";
import Select from "react-select";
import { FiFilter } from "react-icons/fi";
import exportIcon from "../../assets/images/export-icon.svg";
import totalRequestIcon from "../../assets/images/total-request-icon.svg";
import activeJobsIcon from "../../assets/images/active-jobs-icon.svg";
import deployedJobIcon from "../../assets/images/deployed-jobs-icon.svg";
import reloadIcon from "../../assets/images/reload-icon.svg";
import expandIcon from "../../assets/images/expand-icon.svg";
import urgentWebIcon from "../../assets/images/urgent-icon.svg";
import inProgressWebIcon from "../../assets/images/inprogress-icon.svg";
import dotsIconWeb from "../../assets/images/dots-icon-grey.svg";
import standardWebIcon from "../../assets/images/standard-icon.svg";
import dispatchedWebIcon from "../../assets/images/dispatched-icon.svg";
import editActIcon from "../../assets/images/edit-check-icon.svg";
import approveCheckIcon from "../../assets/images/approve-check-icon.svg";
import rejectCloseIcon from "../../assets/images/reject-close-icon.svg";
import rejectBtnCrossIcon from "../../assets/images/rejected-white-cross-icon.svg";
import approveCircleCheckIcon from "../../assets/images/approve-check-white-icon.svg";
import arrowRightIconWt from "../../assets/images/dispatch-white-arrow.svg";
import yesCircleIcon from "../../assets/images/yes-green-icon.svg";
import partialCircleIcon from "../../assets/images/partial-orange-icon.svg";
import filterToggleIcon from "../../assets/images/filter-search-icon.svg";
import highPriorityIcon from "../../assets/images/high-priority-icon.svg";
import LowPriorityIcon from "../../assets/images/low-priority-icon.svg";
import inprogressStatusIcon from "../../assets/images/inprogress-status-icon.svg";
import deployedStatusIcon from "../../assets/images/deployed-status-icon.svg";
import additionStatusIcon from "../../assets/images/additional-asset-status-icon.svg";
import fileTextIconWeb from "../../assets/images/file-text-icon.svg";
import editTextIconWeb from "../../assets/images/edit-text-icon.svg";
import searchTextIcon from "../../assets/images/search-text-icon.svg";
import FullScreenLoader from "../../Component/Loader";

import {
    getStats,
    getFilterOptions,
    getJobs,
    exportJobsData,
    getAllStatus
} from "../../Services/dashboard";

import { getRequestList, getRequestStats, exportResupply, getPriorityList, updateReSupplyRequest } from "../../Services/resupply";

import "./style.css";

// Helper to convert date filter label to API date_range string
const getDateRangeValue = (label) => {
    if (label === "All") return "";
    const map = {
        "Last 24 hrs": "last_24_hours",
        "Last 12 hrs": "last_12_hours",
        "Last 1 week": "last_week",
        "Last 1 month": "last_month",
        "Last 1 year": "last_year",
    };
    return map[label] || "";
};

const Dashboard = () => {
    const navigate = useNavigate();
    const [showLoader, setShowLoader] = useState(false);
    const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);

    // Filter options from API (only used for dropdowns if needed later)
    const [regionOptions, setRegionOptions] = useState([]);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [jobOptions, setJobOptions] = useState([]);
    const [salesManOptions, setSalesManOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);
    const [jobNameOptions, setJobNameOptions] = useState([]);
    const [selectedPortalJobName, setSelectedPortalJobName] = useState('');
    const [portalJobOptions, setPortalJobOptions] = useState([]);

    // Global filter states
    const [searchQuery, setSearchQuery] = useState("");
    const [dateFilter, setDateFilter] = useState("All");

    // Offcanvas filter states
    const [filterRequestId, setFilterRequestId] = useState("");
    const [filterJobDetailsId, setFilterJobDetailsId] = useState("");
    const [filterJobName, setFilterJobName] = useState("");
    const [filterPriority, setFilterPriority] = useState(null);
    const [filterStatus, setFilterStatus] = useState(null);
    const [filterPrimaryBasin, setFilterPrimaryBasin] = useState(null);
    const [priorityOptions, setPriorityOptions] = useState([]);

    // Stats & table data
    const [statsData, setStatsData] = useState({});
    const [tableData, setTableData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [exporting, setExporting] = useState(false);
    const [requestStats, setRequestStats] = useState({
        "Total_requests": 0,
        "Pending_Approval": 0,
        "Approved_request": 0,
        "Partial_Dispatched_Count": 0,
        "Resupply_Completed_Count": 0
    });

    const [statusOption, setStatusOption] = useState([]);

    // Get role from localStorage – dynamic
    const [role, setRole] = useState(
        (typeof localStorage !== 'undefined' ? localStorage.getItem('userRole') : 'field tech')?.toLowerCase().trim() || 'field tech'
    );
    // Active filters count (offcanvas filters only)
    const activeFiltersCount = [
        filterRequestId,
        filterJobDetailsId,
        filterJobName,
        filterPriority?.value,
        filterStatus?.value,
        filterPrimaryBasin
    ].filter((v) => v && v !== "").length;

    const dateOptions = [
        "All",
        "Last 24 hrs",
        "Last 12 hrs",
        "Last 1 week",
        "Last 1 month",
        "Last 1 year",
    ];

    // Fetch initial data
    useEffect(() => {
        fetchPriorityOption();
        fetchFilters();
        fetchStats();
        fetchAllStatus();
        fetchRequestStats();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Fetch table data when dependencies change
    useEffect(() => {
        fetchTableData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageNumber,
        pageSize,
        searchQuery,
        dateFilter,
        filterRequestId,
        filterJobDetailsId,
        filterJobName,
        filterPriority,
        filterStatus,
        filterPrimaryBasin,
        selectedPortalJobName
    ]);

    // Clamp pageNumber
    const totalPages = Math.ceil(totalRecords / pageSize) || 1;
    useEffect(() => {
        if (pageNumber > totalPages) {
            setPageNumber(totalPages);
        }
    }, [totalPages, pageNumber]);

    // API calls
    const fetchStats = async () => {
        let res = await getStats(localStorage.access_token);
        if (res?.data && res?.data?.status_code == 200) {
            setStatsData(res?.data?.result?.result);
        }
    };

    const fetchRequestStats = async () => {
        let res = await getRequestStats(localStorage.access_token);
        if (res && res?.data && res?.data?.status == 200) {
            setRequestStats(res?.data?.data[0]);
        }
    };

    const fetchFilters = async () => {
        setShowLoader(true);
        let res = await getFilterOptions(localStorage.access_token);
        setShowLoader(false);
        if (res?.data?.status_code === 200) {
            const result = res.data.result;
            setRegionOptions(mapToOptions(result?.selected_country));
            setCustomerOptions(mapToOptions(result?.customer));
            setJobOptions(mapToOptions(result?.job_type));
            setSalesManOptions(mapToOptions(result?.sales_name));
            setStatusOptions(mapToOptions(result?.status));
            setJobNameOptions(mapToOptions(result?.job_name));
            setPortalJobOptions(mapToOptions(result?.Portal_jobs))

        }
    };

      const getSelectedOption = (options, value) => {
        return options.find(option => option.value === value) || options.find(option => option.value === '');
    };

    const fetchAllStatus = async () => {
        let res = await getAllStatus(localStorage.access_token);
        if (res && res?.data && res?.data?.status == 200) {
            const options = res?.data?.data.map((item) => ({
                value: item.ID,
                label: item.Status,
            }));
            setStatusOption([{ value: "", label: "All" }, ...options]);
        }
    };

    // Updated: priority options now use label as value and include "All"
    const fetchPriorityOption = async () => {
        let res = await getPriorityList(localStorage.access_token);
        if (res && res?.data && res?.data?.status == 200) {
            const options = res?.data?.data.map((item) => ({
                value: item.Priority,      // use Priority name as value, not ID
                label: item.Priority,
            }));
            // Prepend "All" option with empty string value
            setPriorityOptions([{ value: "", label: "All" }, ...options]);
        }
    };

    const fetchTableData = async () => {
        setLoading(true);
        try {
            const payload = {
                page_number: pageNumber,
                page_size: pageSize,
                request_id: filterRequestId,
                date_range: getDateRangeValue(dateFilter),
                job_details_id: filterJobDetailsId,
                job_name: filterJobName || searchQuery,
                priority: filterPriority?.value || "",
                status: filterStatus?.value || "",
                Primary_Basin: filterPrimaryBasin,
                Portal_JobName: selectedPortalJobName
            };
            let res = await getRequestList(localStorage.access_token, payload);
            if (res && res?.data && res?.data?.status == 200) {
                // Access total_records and data correctly
                setTableData(res?.data?.data?.data || []);
                setTotalRecords(parseInt(res?.data?.data?.total_records) || 0);
            } else {
                setTableData([]);
                setTotalRecords(0);
            }
        } catch (error) {
            console.error("Error fetching table data:", error);
            setTableData([]);
            setTotalRecords(0);
        } finally {
            setLoading(false);
        }
    };
    // Export function using the resupply export API
    const handleExport = async () => {
        setExporting(true);
        try {
            const payload = {
                request_id: filterRequestId,
                date_range: getDateRangeValue(dateFilter),
                job_details_id: filterJobDetailsId,
                job_name: filterJobName || searchQuery,
                priority: filterPriority?.value || "",   // now sends priority label or empty
                status: filterStatus?.value || "",
                filterPrimaryBasin: filterPrimaryBasin
            };
            const res = await exportResupply(localStorage.access_token, payload);
            if (res?.data) {
                let csvContent = "";
                if (typeof res.data === "string") {
                    csvContent = res.data;
                } else if (res.data?.data && typeof res.data.data === "string") {
                    csvContent = res.data.data;
                } else if (res.data instanceof Blob) {
                    const url = window.URL.createObjectURL(res.data);
                    const link = document.createElement("a");
                    link.href = url;
                    const contentDisposition = res.headers?.["content-disposition"];
                    let filename = "resupply_export.csv";
                    if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
                        if (filenameMatch && filenameMatch.length > 1) {
                            filename = filenameMatch[1];
                        }
                    }
                    link.setAttribute("download", filename);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    setExporting(false);
                    return;
                }
                if (csvContent) {
                    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    const now = new Date();
                    const dateStr = `${now.getFullYear()}${(now.getMonth() + 1)
                        .toString()
                        .padStart(2, "0")}${now.getDate().toString().padStart(2, "0")}`;
                    const filename = `resupply_export_${dateStr}.csv`;
                    link.setAttribute("download", filename);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                } else {
                    throw new Error("No CSV data found in response");
                }
            } else {
                throw new Error("Empty response from server");
            }
        } catch (error) {
            console.error("Error exporting resupply data:", error);
            alert("Failed to export data. Please try again.");
        } finally {
            setExporting(false);
        }
    };

    const mapToOptions = (arr = []) => [
        { value: "", label: "All" },
        ...arr.map((item) => ({
            value: item,
            label: item,
        })),
    ];

    // Filter handlers
    const handleApplyFilters = () => {
        setPageNumber(1);
        setShowFiltersDrawer(false);
    };

    const handleClearAllFilters = () => {
        setFilterRequestId("");
        setFilterJobDetailsId("");
        setFilterJobName("");
        setSelectedPortalJobName('')
        setFilterPriority(null);
        setFilterStatus(null);
        setSearchQuery("");
        setDateFilter("All");
        setPageNumber(1);
        setShowFiltersDrawer(false);
    };

    // Pagination handlers
    const handlePageSizeChange = (size) => {
        setPageSize(size);
        setPageNumber(1);
    };

    const handlePageChange = (page) => {
        const target = Math.min(Math.max(1, page), totalPages);
        setPageNumber(target);
    };

    // Helper functions for UI styling
    const getStatusIcon = (status) => {
        switch (status?.toLowerCase()) {
            case "inprogress":
                return inprogressStatusIcon;
            case "deployed":
                return deployedStatusIcon;
            case "additional asset":
                return additionStatusIcon;
            default:
                return inprogressStatusIcon;
        }
    };

    const getStatusClass = (status) => {
        switch (status?.toLowerCase()) {
            case "inprogress":
                return "btn-inprogress-txt";
            case "deployed":
                return "btn-deployed-txt";
            case "additional asset":
                return "btn-addt-asst-txt";
            default:
                return "btn-inprogress-txt";
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
        });
    };

    const getPaginationItems = () => {
        const total = Math.max(1, totalPages);
        const current = Math.min(pageNumber, total);
        const items = []
        const maxVisiblePages = 7;

        if (total <= maxVisiblePages) {
            for (let i = 1; i <= total; i++) {
                items.push(i);
            }
        } else {
            items.push(1);
            let startPage = Math.max(2, current - 2);
            let endPage = Math.min(total - 1, current + 2);
            if (current <= 3) {
                endPage = Math.min(total - 1, 5);
            }
            if (current >= total - 2) {
                startPage = Math.max(2, total - 4);
            }
            if (startPage > 2) {
                items.push("...");
            }
            for (let i = startPage; i <= endPage; i++) {
                items.push(i);
            }
            if (endPage < total - 1) {
                items.push("...");
            }
            if (total > 1) {
                items.push(total);
            }
        }
        return items;
    };

    const getPriorityColor = (priority) => {
        if (!priority)
            return { backgroundColor: "#ffac5926", color: "#DE6F00" };
        const p = priority.toLowerCase();
        if (p === "high")
            return { backgroundColor: "#ffb2812e", color: "#AD2300" };
        if (p === "medium")
            return { backgroundColor: "#ffac5926", color: "#DE6F00" };
        if (p === "low")
            return { backgroundColor: "#c2f0c2", color: "#046e05" };
        return { backgroundColor: "#ffac5926", color: "#DE6F00" };
    };

    const getStatusColor = (status) => {
        if (typeof status === "number") return
        if (!status) return { backgroundColor: "#e9ecef", color: "#495057" };
        const s = status.toLowerCase();
        if (s === "not started")
            return { backgroundColor: "#e9ecef", color: "#495057" };
        if (s === "completed")
            return { backgroundColor: "#d4edda", color: "#155724" };
        if (s === "in progress")
            return { backgroundColor: "#fff3cd", color: "#856404" };
        if (s === "request raised")
            return { backgroundColor: "#cce5ff", color: "#004085" };
        if (s === "approved")
            return { backgroundColor: "#d1ecf1", color: "#0c5460" };
        if (s === "rejected")
            return { backgroundColor: "#f8d7da", color: "#721c24" };
        if (s === "dispatched")
            return { backgroundColor: "#ffe5b4", color: "#8a6d3b" };
        if (s === "resupply completed")
            return { backgroundColor: "#b7e4c7", color: "#1e6f3f" };
        if (s === "deployed")
            return { backgroundColor: "#b7e4c7", color: "#1e6f3f" };
        return { backgroundColor: "#e9ecef", color: "#495057" };
    };

    const handleEditRequest = (val) => {
        navigate(`/home/${val?.JobDetails_ID}/${val?.Request_ID}/${val?.Deal_ID}/${val?.Country}`);
    };

    let handleStatusUpdate = async (val, status) => {
        setShowLoader(true)
        const payload = {
            JobDetails_ID: val?.JobDetails_ID ?? "",
            Request_ID: val?.Request_ID ?? "",
            Needed_On: val?.Needed_On ?? "",
            Status: status,
            priority: val?.Priority ?? "",
            comments: "",
            Expected_Delivery_Date: val?.Expected_Delivery_Date ?? "",
        }

        const res = await updateReSupplyRequest(payload, localStorage.access_token);
        fetchTableData()
        fetchStats()
        setShowLoader(false);
        if (res?.data?.data?.status_code === 200) {
            toast.success(res.data.data.message);
        }
        else if (res?.data?.data?.status_code === 403) {
            toast.error(res.data.data.message);
        }
    }

    let handleViewSummary = (val) => {
        console.log("val ->", val)
        navigate(`/summary/${val?.Deal_ID}/${val?.JobDetails_ID}/${val?.Request_ID}/${val?.Country}`)
    }

    // Role-based table rendering
    const renderOpsTable = () => {
        return (
            <Table responsive className="chart-table-jobweb mb-0" style={{ minHeight: "500px" }}>
                <thead className="request-theadtable">
                    <tr>
                        <th>Request ID</th>
                        <th>Job details Id</th>
                        <th>Job name</th>
                        <th className="text-center">Needed on</th>
                        <th>Priority</th>
                        <th>Status</th>
                        <th className="text-center">Actions</th>
                    </tr>
                </thead>
                <tbody className="request-tbodytable">
                    {loading ? (
                        <tr>
                            <td colSpan="7" className="text-center py-4">Loading...</td>
                        </tr>
                    ) : tableData.length === 0 ? (
                        <tr>
                            <td colSpan="7" className="text-center py-4">No data available</td>
                        </tr>
                    ) : (
                        tableData.map((val, i) => (
                            <tr key={i}>
                                <td className="align-top"><span className="reqst-txtwl-b">{val?.Request_ID}</span></td>
                                <td className="align-top"><span className="reqst-txtwl-b">{val?.JobDetails_ID}</span></td>
                                <td className="align-top"><span className="reqst-txtwl-b">{val?.JobName}</span></td>
                                <td className="text-center align-top">
                                    <span className="reqst-txtwl-l">{val?.Needed_On ? val.Needed_On.split(" ")[0] : "-"}</span>
                                </td>
                                <td className="align-top">
                                    <button type="button" className="btn btn-urgent-wp" style={getPriorityColor(val?.Priority)}>
                                        {val?.Priority}
                                    </button>
                                </td>
                                <td className="align-top">
                                    <button type="button" className="btn btn-inprgres-wp" style={getStatusColor(val?.Status)}>
                                        {val?.Status}
                                    </button>
                                </td>
                                <td className="text-center align-top">
                                    <Dropdown>
                                        <Dropdown.Toggle variant="" className="btn-dots-wp">
                                            <img src={dotsIconWeb} alt="" />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="action-menu-dropdown">
                                            <Dropdown.Item onClick={() => handleViewSummary(val)} className="itm-drop-act">
                                                <img src={fileTextIconWeb} className="me-2" alt="" />
                                                View Summary
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => handleEditRequest(val)} className="itm-drop-act">
                                                <img src={editTextIconWeb} className="me-2" alt="" />
                                                Edit Request
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        );
    };

    let handleEditClick = (val) => {
        let url = `/home/${val?.JobDetails_ID}/${val.Request_ID}/${val?.Deal_ID}/${val?.Country}`
        navigate(url)
    }

    const renderManagerTable = () => {
        return (
            <Table responsive className="chart-table-jobweb mb-0">
                <thead className="request-theadtable">
                    <tr>
                        <th>Request ID</th>
                        <th>Job Id</th>
                        <th>Job</th>
                        <th className="text-center">Requested by</th>
                        <th className="text-center">Needed on</th>
                        <th>Priority</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody className="job-tbodytable">
                    {loading ? (
                        <tr><td colSpan="8" className="text-center py-4">Loading...</td></tr>
                    ) : tableData.length === 0 ? (
                        <tr><td colSpan="8" className="text-center py-4">No data available</td></tr>
                    ) : (
                        tableData.map((val, i) => (
                            <tr key={i}>
                                <td><span className="reqst-txtwl-b">{val?.Request_ID}</span></td>
                                <td><span className="reqst-txtwl-b">{val?.JobDetails_ID}</span></td>
                                <td><span className="reqst-txtwl-l">{val?.JobName}</span></td>
                                <td><span className="reqst-txtwl-l text-center">{val?.Requested_By}</span></td>
                                <td>
                                    <span className="reqst-txtwl-l text-center">
                                        {val?.Needed_On ? val.Needed_On.split(" ")[0] : "-"}
                                    </span>
                                </td>
                                <td>
                                    <button type="button" className="btn btn-urgent-wp" style={getPriorityColor(val?.Priority)}>
                                        {val?.Priority}
                                    </button>
                                </td>
                                <td className="align-top">
                                    <button type="button" className="btn btn-inprgres-wp" style={getStatusColor(val?.Status)}>
                                        {val?.Status}
                                    </button>
                                </td>
                                <td className="text-center">
                                    <div className="mult-btn--flw">
                                        <div className="edit-act-btn">
                                            <button onClick={() => handleEditClick(val)} type="button" className="btn btn-edit-act"><img src={editActIcon} alt="" /></button>
                                        </div>
                                        {/* {val?.Status === 'Approved' ? (
                                            <div className="flw-btn--wp d-flex align-items-center ps-4">
                                                <button style={{ borderColor: '#7f8380', backgroundColor: '#7f8380' }} disabled type="button" className="btn btn-approve-check w-100">
                                                    <img src={approveCheckIcon} className="me-2" alt="" />Approved
                                                </button>
                                            </div>
                                        ) : val?.Status === 'Rejected' ? (
                                            <div className="flw-btn--wp d-flex align-items-center ps-4">
                                                <button style={{ borderColor: '#7f8380', backgroundColor: '#7f8380' }} disabled type="button" className="btn btn-approve-check w-100">
                                                    <img src={rejectCloseIcon} className="me-2" alt="" />Rejected
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="flw-btn--wp d-flex align-items-center ps-4">
                                                <button
                                                    onClick={() => handleStatusUpdate(val, 5)}
                                                    disabled={val?.Status !== 'Request Raised'}
                                                    type="button"
                                                    className="btn btn-approve-check"
                                                >
                                                    <img src={approveCheckIcon} className="me-2" alt="" />Approve
                                                </button>
                                                <button
                                                    onClick={() => handleStatusUpdate(val, 6)}
                                                    disabled={val?.Status !== 'Request Raised'}
                                                    type="button"
                                                    className="btn btn-reject-wlm ms-2"
                                                >
                                                    <img src={rejectCloseIcon} className="me-2" alt="" />Reject
                                                </button>
                                            </div>
                                        )} */}
                                    </div>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        );
    };

    const renderTechnicianTable = () => {
        return (
            <Table responsive className="chart-table-jobweb mb-0">
                <thead className="request-theadtable">
                    <tr>
                        <th>Request ID</th>
                        <th>Job Id</th>
                        <th>Job</th>
                        {/* <th>Items Requested</th> */}
                        {/* <th className="text-center">Qty</th> */}
                        <th className="text-center">Needed on</th>
                        <th>Priority</th>
                        <th>Status</th>
                        {/* <th>Availability</th> */}
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody className="job-tbodytable">
                    {loading ? (
                        <tr><td colSpan="9" className="text-center py-4">Loading...</td></tr>
                    ) : tableData.length === 0 ? (
                        <tr><td colSpan="9" className="text-center py-4">No data available</td></tr>
                    ) : (
                        tableData.map((val, i) => (
                            <tr key={i}>
                                <td><span className="reqst-txtwl-b">{val?.Request_ID}</span></td>
                                <td><span className="reqst-txtwl-b">{val?.JobDetails_ID}</span></td>
                                <td><span className="reqst-txtwl-l">{val?.JobName}</span></td>
                                {/* <td>
                                    <span className="reqst-txtwl-l">Equipment, Pump,</span>
                                    <p className="textline-disc--wpl">Centrifugal Pump 4 IN ×3</p>
                                </td> */}
                                {/* <td><span className="reqst-txtwl-l text-center">4</span></td> */}
                                <td>
                                    <span className="reqst-txtwl-l text-center">
                                        {val?.Needed_On ? val.Needed_On.split(" ")[0] : "-"}
                                    </span>
                                </td>
                                <td>
                                    <button type="button" className="btn btn-urgent-wp" style={getPriorityColor(val?.Priority)}>
                                        {val?.Priority}
                                    </button>
                                </td>
                                <td className="align-top">
                                    <button type="button" className="btn btn-inprgres-wp" style={getStatusColor(val?.Status)}>
                                        {val?.Status}
                                    </button>
                                </td>
                                {/* <td>
                                    <button type="button" className="btn btn-yes-wp">
                                        <img src={yesCircleIcon} className="me-1" alt="" />Yes
                                    </button>
                                </td> */}
                                <td className="text-center">
                                    <div className="mult-btn--flw" style={{ display: 'flex', justifyContent: "space-evenly" }}>
                                        <div className="edit-act-btn">
                                            <button onClick={() => handleEditClick(val)} type="button" className="btn btn-edit-act"><img src={editActIcon} alt="" /></button>
                                        </div>
                                        {/* <button onClick={() => handleStatusUpdate(val, 7)} disabled = {val?.Status != 'Approved' ? true: false} type="button" className="btn btn-dispatch-btn">
                                            Dispatch <img src={arrowRightIconWt} className="ms-1" alt="" />
                                        </button> */}
                                    </div>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        );
    };

    const renderTable = () => {
        switch (role.toLowerCase()) {
            case "field tech": return renderOpsTable();
            case "field leader": return renderManagerTable();
            case "area manager": return renderManagerTable();
            case "supply chain": return renderTechnicianTable();
            default: return renderOpsTable();
        }
    };

    const renderPagination = () => (
        <div className="d-md-flex align-md-items-center justify-content-md-between p-3 bg-white">
            <div className="dropdown-page-numb d-flex align-items-center mb-3 mb-md-0 justify-content-center">
                <div className="d-inline-block txtlabel-bt pe-2">
                    <span className="txt-label-wts">Per Page</span>
                </div>
                <Dropdown className="dropdown-page-count">
                    <Dropdown.Toggle variant="success" className="btn-select-dropcount">
                        {pageSize}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="dropdown-menu-count">
                        <Dropdown.Item onClick={() => handlePageSizeChange(10)}>10</Dropdown.Item>
                        <Dropdown.Item onClick={() => handlePageSizeChange(20)}>20</Dropdown.Item>
                        <Dropdown.Item onClick={() => handlePageSizeChange(50)}>50</Dropdown.Item>
                        <Dropdown.Item onClick={() => handlePageSizeChange(100)}>100</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <div className="pagination-table-web">
                <Pagination className="mb-0 justify-content-center">
                    <Pagination.First onClick={() => handlePageChange(1)} disabled={pageNumber === 1} />
                    <Pagination.Prev onClick={() => handlePageChange(pageNumber - 1)} disabled={pageNumber === 1} />
                    {getPaginationItems().map((item, index) => {
                        if (item === "...") {
                            return <Pagination.Ellipsis key={`ellipsis-${index}`} disabled />;
                        }
                        return (
                            <Pagination.Item
                                key={item}
                                active={pageNumber === item}
                                onClick={() => handlePageChange(item)}
                            >
                                {item}
                            </Pagination.Item>
                        );
                    })}
                    <Pagination.Next
                        onClick={() => handlePageChange(pageNumber + 1)}
                        disabled={pageNumber === totalPages}
                    />
                    <Pagination.Last
                        onClick={() => handlePageChange(totalPages)}
                        disabled={pageNumber === totalPages}
                    />
                </Pagination>
            </div>
        </div>
    );

    return (
        <>
            <div className="wrapper">
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                    draggable
                    theme="colored"
                />
                <Header />
                {showLoader ? <FullScreenLoader /> : null}
                <div className="full-dashboard-body">
                    {/* Top Header Section */}
                    <div className="top-head-jobcontent">
                        <Container fluid>
                            <Row>
                                <Col xs={12}>
                                    <div className="d-sm-flex flex-sm-wrap align-items-sm-center">
                                        <div className="heading-job-upcoming mb-3 mb-sm-0">
                                            <h2 className="title-h2 mb-0">Resupply Request Allocation</h2>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <Dropdown className="me-2">
                                                <Dropdown.Toggle variant="" className="btn-filter-days">
                                                    <span className="flt-wgt--serach d-inline-block me-2">
                                                        <img src={filterToggleIcon} alt="" />
                                                    </span>
                                                    {dateFilter}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className="dropmnu-filter-web">
                                                    {dateOptions.map((opt) => (
                                                        <Dropdown.Item
                                                            key={opt}
                                                            onClick={() => {
                                                                setDateFilter(opt);
                                                                setPageNumber(1);
                                                            }}
                                                        >
                                                            {opt}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            <button
                                                type="button"
                                                className="btn btn-export-web"
                                                onClick={handleExport}
                                                disabled={exporting}
                                            >
                                                {exporting ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                        Exporting...
                                                    </>
                                                ) : (
                                                    <>
                                                        <img src={exportIcon} className="me-1" alt="" />
                                                        Export
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>

                    {/* Stats Cards */}
                    <div className="job-section-area">
                        <Container fluid>
                            <Row>
                                <Col xs={12} md={6} lg={6} xl={3}>
                                    <Card className="job-card-view">
                                        <div className="job-icon-flx"><img src={totalRequestIcon} alt="" /></div>
                                        <div className="job-info-flx">
                                            <h5 className="total-txt-wt">Total Request</h5>
                                            <h3 className="total-numb-wp">{requestStats?.Total_requests}</h3>
                                        </div>
                                    </Card>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={3}>
                                    <Card className="job-card-view">
                                        <div className="job-icon-flx"><img src={activeJobsIcon} alt="" /></div>
                                        <div className="job-info-flx">
                                            <h5 className="total-txt-wt">Pending Approval</h5>
                                            <h3 className="total-numb-wp">{requestStats?.Pending_Approval}</h3>
                                        </div>
                                    </Card>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={3}>
                                    <Card className="job-card-view">
                                        <div className="job-icon-flx"><img src={deployedJobIcon} alt="" /></div>
                                        <div className="job-info-flx">
                                            <h5 className="total-txt-wt">Approved Request</h5>
                                            <h3 className="total-numb-wp">{requestStats?.Approved_request}</h3>
                                        </div>
                                    </Card>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={3}>
                                    <Card className="job-card-view">
                                        <div className="job-icon-flx"><img src={deployedJobIcon} alt="" /></div>
                                        <div className="job-info-flx">
                                            <h5 className="total-txt-wt">Completed Request</h5>
                                            <h3 className="total-numb-wp">{requestStats?.Resupply_Completed_Count}</h3>
                                        </div>
                                    </Card>
                                </Col>
                                {/* <Col xs={12} md={6} lg={6} xl={3}>
                                    <Card className="job-card-view">
                                        <div className="flex-fill">
                                            <h5 className="total-txt-wt">Request Completion</h5>
                                            <div className="row-dual-flx">
                                                <div className="col-wgt-two">
                                                    <div className="boxstate-gyt bg-color-st-1">
                                                        <span className="state-txt-mtw"><span className="circle-st blue-clr"></span>Partial Dispatched</span>
                                                        <h3 className="total-numb-wp">{requestStats?.Partial_Dispatched_Count}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-wgt-two">
                                                    <div className="boxstate-gyt bg-color-st-2">
                                                        <span className="state-txt-mtw"><span className="circle-st green-clr"></span>Resupply Completed</span>
                                                        <h3 className="total-numb-wp">{requestStats?.Resupply_Completed_Count}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                </Col> */}
                            </Row>
                        </Container>
                    </div>

                    {/* Filter & Search Bar */}
                    <div className="global-filters">
                        <Container fluid>
                            <Row>
                                <Col xs={12} className="text-end">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="search-field-bar">
                                            <div className="position-relative">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Search by Job Name"
                                                    className="search-control-wrt"
                                                    value={searchQuery}
                                                    onChange={(e) => {
                                                        setSearchQuery(e.target.value);
                                                        setPageNumber(1);
                                                    }}
                                                />
                                                <span className="search-txt-icon"><img src={searchTextIcon} alt="" /></span>
                                            </div>
                                        </div>
                                        <div className="filter-button-right">
                                            <button
                                                type="button"
                                                className="btn btn-primary d-inline-flex align-items-center global-filtr-btn position-relative"
                                                style={{ borderRadius: "8px", padding: "8px 20px" }}
                                                onClick={() => setShowFiltersDrawer(true)}
                                            >
                                                <FiFilter className="me-2" size={18} />
                                                Filters
                                                {activeFiltersCount > 0 && (
                                                    <Badge bg="light" text="dark" className="ms-2 rounded-pill">
                                                        {activeFiltersCount}
                                                    </Badge>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>

                    {/* Table Section */}
                    <div className="full-tablejob-contain pb-4">
                        <Container fluid>
                            <Row>
                                <Col xs={12}>
                                    <div className="tablecontent-job-lstwp">
                                        {renderTable()}
                                        {renderPagination()}
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </div>

            {/* Filters Drawer */}
            <Offcanvas
                show={showFiltersDrawer}
                onHide={() => setShowFiltersDrawer(false)}
                placement="end"
                scroll={true}
                backdrop={true}
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Filter Jobs</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Request Id</Form.Label>
                            <div className="position-relative">
                                <Form.Control
                                    type="text"
                                    placeholder=""
                                    className="search-control-wrt"
                                    style={{
                                        borderColor: "hsl(0, 0%, 80%)",
                                        borderRadius: "4px",
                                        borderStyle: "solid",
                                        borderWidth: "1px",
                                        paddingLeft: "5px"
                                    }}
                                    value={filterRequestId}
                                    onChange={(e) => setFilterRequestId(e.target.value)}
                                />
                            </div>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Job details Id</Form.Label>
                            <div className="position-relative">
                                <Form.Control
                                    type="text"
                                    placeholder=""
                                    className="search-control-wrt"
                                    style={{
                                        borderColor: "hsl(0, 0%, 80%)",
                                        borderRadius: "4px",
                                        borderStyle: "solid",
                                        borderWidth: "1px",
                                        paddingLeft: "5px"
                                    }}
                                    value={filterJobDetailsId}
                                    onChange={(e) => setFilterJobDetailsId(e.target.value)}
                                />
                            </div>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Job name</Form.Label>
                            <div className="position-relative">
                                <Form.Control
                                    type="text"
                                    placeholder=""
                                    className="search-control-wrt"
                                    style={{
                                        borderColor: "hsl(0, 0%, 80%)",
                                        borderRadius: "4px",
                                        borderStyle: "solid",
                                        borderWidth: "1px",
                                        paddingLeft: "5px"
                                    }}
                                    value={filterJobName}
                                    onChange={(e) => setFilterJobName(e.target.value)}
                                />
                            </div>
                        </Form.Group>

                        

                        {/* <Form.Group className="mb-3">
                            <Form.Label>Portal Job Name</Form.Label>
                            <Select
                                classNamePrefix="react-select-filter"
                                options={portalJobOptions}
                                placeholder="Select"
                                isSearchable={true}
                                value={getSelectedOption(portalJobOptions, selectedPortalJobName)}
                                onChange={(option) => setSelectedPortalJobName(option.value)}
                                // menuPortalTarget={document.body}
                                menuShouldScrollIntoView={false}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Form.Group> */}

                        <Form.Group className="mb-3">
                            <Form.Label>Primary Basin</Form.Label>
                            <div className="position-relative">
                                <Form.Control
                                    type="text"
                                    placeholder=""
                                    className="search-control-wrt"
                                    style={{
                                        borderColor: "hsl(0, 0%, 80%)",
                                        borderRadius: "4px",
                                        borderStyle: "solid",
                                        borderWidth: "1px",
                                        paddingLeft: "5px"
                                    }}
                                    value={filterPrimaryBasin}
                                    onChange={(e) => setFilterPrimaryBasin(e.target.value)}
                                />
                            </div>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Priority</Form.Label>
                            <Select
                                classNamePrefix="react-select-filter"
                                options={priorityOptions}
                                placeholder="Select"
                                isSearchable={true}
                                value={filterPriority}
                                onChange={(selected) => setFilterPriority(selected)}
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Status</Form.Label>
                            <Select
                                classNamePrefix="react-select-filter"
                                options={statusOption}
                                placeholder="Select"
                                isSearchable={true}
                                value={filterStatus}
                                onChange={(selected) => setFilterStatus(selected)}
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Form.Group>

                        <div className="d-flex gap-2 mt-4">
                            <Button variant="primary" onClick={handleApplyFilters} className="flex-grow-1 global-filtr-btn">
                                Apply
                            </Button>
                            <Button variant="outline-secondary" onClick={handleClearAllFilters} className="flex-grow-1 global-filtr-btn">
                                Clear All
                            </Button>
                        </div>
                    </Form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default Dashboard;